import React from 'react'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Button } from 'shared/components/Button/Button'
import { PolicyStatusBadge } from 'shared/components/Policies/PolicyStatusBadge'
import { Text } from 'shared/components/Text/Text'
import { lightGray1, midGray, primaryBlack } from 'shared/theme/colors'

import { PolicyStatusText, Repayment, RepaymentPolicyStatus } from '../../../models/repayments'
import { getPolicyHeader, getPolicyStatus } from '../Policy.helper'

interface PolicyDetailHeaderProps {
  policy: Repayment
  teamUrl?: string
  children?: React.ReactNode
}

export function PolicyDetailHeader({ policy, teamUrl, children }: PolicyDetailHeaderProps) {
  const policyHeader = getPolicyHeader(policy)
  const status = getPolicyStatus(policy)

  return (
    <>
      <FlexBox alignItems="center" gap="20px">
        <Text variant="header2">{policyHeader}</Text>

        <PolicyStatusBadge $status={RepaymentPolicyStatus[status]}>
          <Text variant="header3">{PolicyStatusText[status]}</Text>
        </PolicyStatusBadge>

        {children}
      </FlexBox>

      <FlexBox alignItems="center" gap="20px" mt={2}>
        <Text variant="header3" fontColor={lightGray1}>
          Fleet name
        </Text>
        {teamUrl ? (
          <Button variant="text" href={teamUrl}>
            {policy.repayment_details.team_name}
          </Button>
        ) : (
          <Text variant="header3" fontColor={primaryBlack}>
            {policy.repayment_details.team_name}
          </Text>
        )}
      </FlexBox>

      {policy.repayment_details.equipment ? (
        <FlexBox alignItems="center" gap="20px" mt={1}>
          <Text variant="header3" fontColor={lightGray1}>
            Associated Truck
          </Text>
          {policy.repayment_details.equipment && (
            <Text variant="header3" fontColor={primaryBlack}>
              {policy.repayment_details.equipment.license_plate_state}-
              {policy.repayment_details.equipment.license_plate_number}
            </Text>
          )}
        </FlexBox>
      ) : null}

      <Text variant="label2" fontColor={midGray} mt={1}>
        {policy.repayment_details.policy_description}
      </Text>
    </>
  )
}
